import { render } from "./Translations.vue?vue&type=template&id=16fbe4c8"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"
script.render = render

export default script